export const HeaderReducer = (prevState = { entryGroup: undefined }, action) => {
  let { type, payload } = action
  switch (type) {
    case 'set_entryGroup':
      let newstate = { ...prevState }
      newstate.entryGroup = payload
      return newstate
    default:
      return prevState
  }
}